import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-column-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-column-modal.component.html',
  styleUrl: './add-column-modal.component.scss'
})
export class AddColumnModalComponent {
  activeModal = inject(NgbActiveModal);
  columnName: string = '';
  errorMessage: string = '';
  isActive: boolean = false;

  onInputChange() {
    // Validate: only allow alphanumeric and underscores
    const regex = /^\w*$/;
    
    if (!this.columnName) {
      this.errorMessage = '';
    } else if (!regex.test(this.columnName)) {
      this.errorMessage = 'Only letters, numbers, and underscores are allowed.';
    } else {
      this.errorMessage = '';
    }
  }
  
  isValid(): boolean {
    const regex = /^\w+$/;
    return this.columnName.trim() !== '' && regex.test(this.columnName);
  }
  
  close() {
    if (this.isValid()) {
      this.activeModal.close(this.columnName);
    }
  }

}
